import api from "./axiosInstance";

/**
 * Challan API Service
 * Handles all challan related API calls
 */

export const challanApi = {
  /**
   * Search challans with pagination and filters
   * GET /api/v1/challans/searchChallans
   */
  searchChallans: (params = {}) => {
    return api.get("challans/searchChallans", { params });
  },

  /**
   * Check if challan number is available
   * GET /api/v1/challans/checkChallanNumber
   */
  checkChallanNumberAvailability: (challanNumber) => {
    return api.get("challans/checkChallanNumber", { params: { challanNumber } });
  },

  /**
   * Get next available manual challan number
   * GET /api/v1/challans/nextAvailableManualChallanNumber
   */
  getNextAvailableManualChallanNumber: (preferredNumber) => {
    return api.get("challans/nextAvailableManualChallanNumber", { 
      params: { preferredNumber } 
    });
  },

  /**
   * Get all challans
   * GET /api/v1/challans
   */
  getAllChallans: () => {
    return api.get("challans");
  },

  /**
   * Get challan by ID
   * GET /api/v1/challans/getByChallanId/{id}
   */
  getChallanById: (id) => {
    return api.get(`challans/getByChallanId/${id}`);
  },

  /**
   * Get challan by challan number
   * GET /api/v1/challans/getByChallanId/{id}
   */
  getChallanByChallanId: (id) => {
    return api.get(`challans/getByChallanId/${id}`);
  },

  /**
   * Create new challan
   * POST /api/v1/challans/create
   */
  createChallan: (data) => {
    return api.post("challans/create", data);
  },

  /**
   * Update challan
   * PUT /api/v1/challans/updateChallanById/{id}
   */
  updateChallan: (id, data) => {
    return api.put(`challans/updateChallanById/${id}`, data);
  },

  /**
   * Delete challan by ID
   * DELETE /api/v1/challans/deleteChallanById/{id}
   */
  deleteChallanById: (id) => {
    return api.delete(`challans/deleteChallanById/${id}`);
  },

  /**
   * Download challan PDF
   * GET /api/v1/challans/download/{id}
   */
  downloadChallan: (id) => {
    return api.get(`challans/download/${id}`, {
      responseType: 'blob'
    });
  },

  /**
   * Get customer passbook
   * GET /api/v1/challans/passbook
   */
  getPassbook: (params) => {
    return api.get("challans/passbook", { params });
  },

  /**
   * Get passbook summary
   * GET /api/v1/challans/getPassbookSummary
   */
  getPassbookSummary: (params) => {
    return api.get("challans/getPassbookSummary", { params });
  },

  /**
   * Get customer inventory items
   * GET /api/v1/challans/getCustomersInventoryItems/{id}
   */
  getCustomerInventoryItems: (id) => {
    return api.get(`challans/getCustomersInventoryItems/${id}`);
  },

  /**
   * Create combined challan
   * POST /api/v1/challans/create-combined
   */
  createCombinedChallan: (data) => {
    return api.post("challans/create-combined", data);
  },

  /**
   * Update combined challan
   * PUT /api/v1/challans/combined/{id}
   */
  updateCombinedChallan: (id, data) => {
    return api.put(`challans/combined/${id}`, data);
  },

  /**
   * Get combined challan by ID
   * GET /api/v1/challans/combined/{id}
   */
  getCombinedChallan: (id) => {
    return api.get(`challans/combined/${id}`);
  }
};

export default challanApi;
